<template>
  <div class="demo-status-bar">
    <div class="demo-status-bar__heading">
      <h6 class="demo-status-bar__title">
        {{ $t('OVERVIEW_REPORTS.MEETING_DEMO_STATUS.TITLE') }}
      </h6>
    </div>
    <div class="demo-status-bar__counters">
      <div class="demo-status-bar__counter">
        <span class="demo-status-bar__label demo-status-bar__label--done">
          {{ $t('OVERVIEW_REPORTS.MEETING_DEMO_STATUS.DEMO_COMPLETED') }}:
        </span>
        <span class="demo-status-bar__value demo-status-bar__value--done">
          {{ doneCount }}
        </span>
      </div>
      <div class="demo-status-bar__counter">
        <span class="demo-status-bar__label demo-status-bar__label--not-done">
          {{ $t('OVERVIEW_REPORTS.MEETING_DEMO_STATUS.DEMO_NOT_COMPLETED') }}:
        </span>
        <span class="demo-status-bar__value demo-status-bar__value--not-done">
          {{ notDoneCount }}
        </span>
      </div>
      <div class="demo-status-bar__counter">
        <span class="demo-status-bar__label demo-status-bar__label--very-good">
          {{ $t('OVERVIEW_REPORTS.MEETING_DEMO_STATUS.VERY_GOOD_DEMOS') }}:
        </span>
        <span class="demo-status-bar__value demo-status-bar__value--very-good">
          {{ veryGoodCount }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeetingDemoStatusBar',
  props: {
    doneCount: {
      type: Number,
      default: 0,
    },
    notDoneCount: {
      type: Number,
      default: 0,
    },
    veryGoodCount: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-status-bar {
  @apply w-full pt-3 mt-1 border-t border-slate-75 dark:border-slate-700;
}

.demo-status-bar__heading {
  @apply flex flex-row items-center gap-2;
}

.demo-status-bar__title {
  @apply mb-0 text-sm font-medium text-slate-800 dark:text-slate-100;
}

.demo-status-bar__counters {
  @apply flex flex-row flex-wrap items-center gap-x-8 gap-y-1 mt-2;
}

.demo-status-bar__counter {
  @apply flex flex-row items-baseline gap-1.5;
}

.demo-status-bar__label {
  @apply text-sm;
}

.demo-status-bar__label--done,
.demo-status-bar__value--done {
  @apply text-woot-800 dark:text-woot-500;
}

.demo-status-bar__label--not-done,
.demo-status-bar__value--not-done {
  @apply text-red-600 dark:text-red-400;
}

.demo-status-bar__label--very-good,
.demo-status-bar__value--very-good {
  @apply text-green-600 dark:text-green-400;
}

.demo-status-bar__value {
  @apply text-lg font-semibold leading-none;
}
</style>
